var React = require('react');

function NavRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.725952 28L2.35876 26.3672L26.1088 2.61719L27.89 0.984375L31.1556 4.25L29.5228 6.03125L7.40564 28L29.5228 50.1172L31.1556 51.75L27.89 55.1641L26.1088 53.5312L2.35876 29.7812L0.725952 28Z","fill":"white"}));
}

NavRight.defaultProps = {"width":"32","height":"56","viewBox":"0 0 32 56","fill":"none"};

module.exports = NavRight;

NavRight.default = NavRight;
